export default __webpack_public_path__ + "static/media/white-mute-icon.95ffe5d9.svg";